const ProjectCard = (props) => {
    const { refpage, imgsource, title, filter, content, hashtag, imgcredit, imgcreditlink } = props;
    return (
        <div className="card cardbox" >
        <div style={{ height: '200px'}} className="project-img-container">
          <a href={refpage}>
            <img
              src={imgsource}
              className="card-img-top"
              alt={title}
              style={{ height: '100%', filter: filter, objectFit: 'cover' }}
            />
          </a>
          {imgcredit && (
            <div className="img-credit-overlay">
              <span>Image: <a href={imgcreditlink} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'underline' }}>{imgcredit}</a></span>
            </div>
          )}
        </div>
        <div className="card-body">
          <h5>{title}</h5>
          <p className="card-text">
           {content}
          </p>
        </div>
        <p className="hashtags">&emsp;{hashtag}</p>
      </div>

    )

}

export default ProjectCard;